import { FC, ButtonHTMLAttributes, ReactNode } from 'react'
import { DefaultButton } from './styles'
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io'
import loaderGreenImg from 'src/assets/loader-green.svg'
import loaderWhiteImg from 'src/assets/loader-white.svg'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'plain' | 'error' | 'outlinedBlue',
  prebuilt?: 'back' | 'next' | 'saveLater' | 'saveContinue' | 'returnTLIE',
  minWidth?: string;
  children?: ReactNode;
  padding?: string;
  isTakingAction?: boolean;
}

const Button: FC<ButtonProps> = ({ children, variant, prebuilt, padding, isTakingAction, disabled, ...rest }) => {
  const isDisabled = isTakingAction === true ? true : disabled

  if(!!prebuilt) {
    switch(prebuilt) {
      case 'back': return <DefaultButton padding={padding} variant="plain" {...rest} disabled={isDisabled} isTakingAction={isTakingAction}>
                            <IoMdArrowBack style={{ marginRight: '5px' }}/>
                            Back
                          </DefaultButton>
      case 'next': return <DefaultButton
                            padding={padding}
                            variant="primary"
                            {...rest}
                            disabled={isDisabled}
                            isTakingAction={isTakingAction}
                          >
                            Next
                          </DefaultButton>
      case 'saveLater': return <DefaultButton
                                  padding={padding}
                                  variant="secondary"
                                  {...rest}
                                  isTakingAction={isTakingAction}
                                  disabled={isDisabled}
                                >
                                  {isTakingAction ? <img src={loaderGreenImg} alt="loading" /> : 'Save for Later'}
                                </DefaultButton>
      case 'saveContinue':
        return <DefaultButton
                  padding={padding}
                  variant="primary"
                  {...rest}
                  style={{ width: '220px' }}
                  disabled={isDisabled}
                  isTakingAction={isTakingAction}
                >
                  {isTakingAction ? <img src={loaderWhiteImg} alt="loading" /> : 'Save & Continue'}
                  {isTakingAction ? null : <IoMdArrowForward style={{ marginLeft: '5px' }} />}
                </DefaultButton>
      case 'returnTLIE': return <DefaultButton
                                  padding={padding}
                                  variant="primary"
                                  {...rest}
                                  disabled={isDisabled}
                                  isTakingAction={isTakingAction}
                                >
                                  Return to TLIE.org
                                </DefaultButton>
    }
  }

  return (
    <DefaultButton
      padding={padding}
      variant={variant ?? 'primary'}
      {...rest}
      isTakingAction={isTakingAction}
      disabled={isDisabled}
    >
      {children}
    </DefaultButton>
  )
}

export default Button